import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Icon } from 'semantic-ui-react';
import { getRemainingMs } from './idleTimeout';

const TICK_MS = 1000;
const WARNING_MS = 5 * 60 * 1000;
const CRITICAL_MS = 60 * 1000;

const LEVEL_COLORS = {
  normal: 'var(--admincat-color-grey-3)',
  warning: '#d9822b',
  critical: '#d64545',
};

export const formatRemaining = (ms) => {
  const totalSeconds = Math.ceil(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
};

const getLevel = (ms) => {
  if (ms <= CRITICAL_MS) return 'critical';
  if (ms <= WARNING_MS) return 'warning';
  return 'normal';
};

// Same height as the avatar, so the icon, the time and the avatar share one
// centre line.
const Countdown = styled.span`
  display: inline-flex;
  align-items: center;
  align-self: center;
  gap: 6px;
  height: 2rem;
  margin-right: 8px;
  color: ${({ $level }) => LEVEL_COLORS[$level]};
  font-weight: ${({ $level }) => ($level === 'normal' ? 500 : 700)};
  line-height: 1;
  white-space: nowrap;
  user-select: none;

  &&& i.icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: auto;
    height: auto;
    margin: 0;
    font-size: 1.1em;
    line-height: 1;
    color: inherit;
  }
`;

const Time = styled.span`
  display: inline-block;
  min-width: 2.6em;
  line-height: 1;
  font-variant-numeric: tabular-nums;
`;

// Time left before the inactivity logout, shown next to the user icon.
const SessionCountdown = ({ tr = (key) => key }) => {
  const [remainingMs, setRemainingMs] = useState(getRemainingMs);

  useEffect(() => {
    const intervalId = setInterval(() => setRemainingMs(getRemainingMs()), TICK_MS);
    return () => clearInterval(intervalId);
  }, []);

  const level = getLevel(remainingMs);
  const label = tr('Automatic logout after inactivity');

  return (
    <Countdown
      $level={level}
      title={label}
      aria-label={`${label}: ${formatRemaining(remainingMs)}`}
      data-testid="session-countdown"
    >
      <Icon name="clock outline" />
      <Time>{formatRemaining(remainingMs)}</Time>
    </Countdown>
  );
};

export default SessionCountdown;
